import { render, staticRenderFns } from "./ParcelDetailsDialog.vue?vue&type=template&id=d18caf4a&scoped=true"
import script from "./ParcelDetailsDialog.vue?vue&type=script&lang=js"
export * from "./ParcelDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./ParcelDetailsDialog.vue?vue&type=style&index=0&id=d18caf4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18caf4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VDivider,VList,VListItem,VListItemContent,VTab,VTabItem,VTabs})
